import { useThemeContext } from '@/context/theme.context'
import { THEMES, type Theme } from '@/constants'

export interface UseThemeReturn {
  theme: Theme
  setTheme: (theme: Theme) => void
  isDark: boolean
  themes: typeof THEMES
}

export function useTheme(): UseThemeReturn {
  const { theme, setTheme } = useThemeContext()

  return {
    theme,
    setTheme,
    isDark: theme === 'dark',
    themes: THEMES,
  }
}
